export default ({ request }) => ({
  orderExecutionLogListApi(data = {}) {
    return request({
      url: '/factory/order/execution/log/list',
      method: 'post',
      data,
    })
  },
  orderExecutionLogDetailApi(data = {}) {
    return request({
      url: '/factory/order/execution/log/detail',
      method: 'post',
      data,
    })
  },
})
